import axios from 'axios';
import { createSignedPatchRequest } from 'utils/createSignedRequestsHelpers';

export const patchAddClient = async ({
  projectId,
  targetOrganizationChartItemId,
  clientBusinessId,
  clientBusinessName,
  activeEmployerInfo,
  clientOrganizationChartItemId,
  existingBusinessActionType,
}) => {
  const apiPath = `organization-charts/project/${projectId}/add-client`;

  const signedRequest = await createSignedPatchRequest({
    apiPath,
    body: {
      targetOrganizationChartItemId,
      clientBusinessId,
      clientBusinessName,
      clientOrganizationChartItemId,
      existingBusinessActionType,
    },
    activeEmployerInfo: activeEmployerInfo,
  });

  const response = await axios(signedRequest);

  return response.data;
};
